import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import Logo from '../../assets/img/logo.png';

const Footer = ({ openBudgetModal }) => {
    const { t } = useTranslation('footer'); // Usando o namespace 'footer'

    return (
        <footer className="footer">
            <div className='container'>
                <hr />

                <div>
                    {/* Logo do Footer (mesma do Header) */}
                    <div className="logo-footer">
                        <img src={Logo} alt="Logo The Worky" />
                    </div>

                    {/* Navegação */}
                    <div className="nav-btns">
                        <nav>
                            <ul>
                                <li><Link to="/sobre">{t('about')}</Link></li>
                                <li><Link to="/servicos">{t('services')}</Link></li>
                                <li>
                                    <button className="open-budget-btn" onClick={openBudgetModal}>{t('budget')}</button>
                                </li>
                                <li><Link to="/cadastro">{t('register')}</Link></li>
                            </ul>
                        </nav>
                    </div>

                </div>

                <div className="contacts">
                    {/* Redes sociais */}
                    <div className="social-btns">
                        <a href="https://www.facebook.com/profile.php?id=61573562105039" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
                        <a href="https://www.linkedin.com/company/theworky/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
                        <a href="https://www.instagram.com/the.worky/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                    </div>
                    {/* Contatos */}
                    <div className="contacts-info">
                        <p><FaEnvelope /> {t('contact_email')} faleconosco@theworky.com</p>
                        <a href="tel:21972132855"><FaPhone /> (21) 99889-7217</a>
                        <p><FaMapMarkerAlt /> {t('location')}</p>
                    </div>
                </div>

                <hr />

                {/* Direitos autorais */}
                <p className="copyright">
                    {t('copyright', { year: new Date().getFullYear() })} | 
                    <Link to="/politica">{t('privacy_policy')}</Link> | 
                    {t('images_credit')} <a href="https://www.freepik.com.br" target="_blank" rel="noopener noreferrer">Freepik</a> e <a href="https://www.unsplash.com" target="_blank" rel="noopener noreferrer">Unsplash</a>
                </p>
                <ul className="links">
                    <li><Link to="/termos#policy">Política de Privacidade</Link></li>
                    <li><Link to="/termos#terms">Termos de Uso</Link></li>
                    <li><Link to="/termos#cookies">Política de Cookies</Link></li>
                </ul>
            </div>

        </footer>
    );
};

export default Footer;
